import React, { FunctionComponent } from "react"
import { Line } from "react-chartjs-2"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { logisticSample } from "@components/Distribution/LogisticDistributionChart/logistic.calc"

interface Props {
  loc: number
  scale: number
  lbound?: number
  ubound?: number
}

export const LogisticDistributionChart: FunctionComponent<Props> = ({
  loc = 1,
  scale = 0,
  lbound = undefined,
  ubound = undefined,
}) => {
  const data = logisticSample(loc, scale, lbound, ubound)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    datasets: [
      {
        data,
        fill: false,
        tension: 0.1,
      },
    ],
  }
  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: "linear",
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        type: "linear",
        title: {
          display: true,
          text: "Probability Density",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
